// extracted by mini-css-extract-plugin
module.exports = {"searchArea":"styles-module--searchArea--2J-3v","container":"styles-module--container--2iUqs","input":"styles-module--input--2p-lk"};